/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useEffect } from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import { useFormik } from 'formik'
import { verifyTwoStep, getUser, getInstanceSettings, getVerificationType } from '../core/_requests'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import { useAuth } from '../core/Auth'
import {VerificationType} from "../core/_models";

const twoFactorSchema = Yup.object().shape({
    code1: Yup.number()
        .min(0)
        .max(9)
        .required(),
    code2: Yup.number()
        .min(0)
        .max(9)
        .required(),
    code3: Yup.number()
        .min(0)
        .max(9)
        .required(),
    code4: Yup.number()
        .min(0)
        .max(9)
        .required(),
    code5: Yup.number()
        .min(0)
        .max(9)
        .required(),
    code6: Yup.number()
        .min(0)
        .max(9)
        .required(),
})

const initialValues = {
    twofactorcode: '',
    code1: '',
    code2: '',
    code3: '',
    code4: '',
    code5: '',
    code6: '',
}

export function TwoFactor() {
    const [loading, setLoading] = useState(false)
    const [verificationType, setVerificationType] = useState<VerificationType>()
    const { saveAuth, tempEmail, setCurrentUser, setInstanceSettings } = useAuth()
    const emailPreview = tempEmail?.emailPreview ?? ''

    useEffect(() => {
        const loadVerificationType = async () => {
            try {
                const email = tempEmail?.email ?? ""
                if (email) {
                    const { data } = await getVerificationType(email)
                    setVerificationType(data)
                }
            } catch (error) {
                console.error('Failed to load verification type:', error)
            }
        }

        loadVerificationType()
    }, [tempEmail])

    const formik = useFormik({
        initialValues,
        validationSchema: twoFactorSchema,
        onSubmit: async (values, { setStatus, setSubmitting }) => {
            setLoading(true)
            try {
                var twofactorcode = formik.values.code1 + formik.values.code2 + formik.values.code3 + formik.values.code4 + formik.values.code5 + formik.values.code6
                var email = tempEmail?.email ?? "";
                const { data: auth } = await verifyTwoStep(twofactorcode, email)
                saveAuth(auth)

                const { data } = await getUser()
                const { data: instanceSettings } = await getInstanceSettings()
                if (data) {
                    setCurrentUser(data)
                    setInstanceSettings(instanceSettings)
                }
            } catch (error) {
                console.error(error)
                saveAuth(undefined)
                setStatus('The login detail is incorrect')
                setSubmitting(false)
                setLoading(false)
            }
        },
    })


    const selectAll = (e: any) => {
        e.target.select()
    }

    const validateCode = (e: any, formik: any) => {
        const re = /^[0-9\b]+$/;
        console.log(e.target.value === '' || re.test(e.target.value))
        if (e.target.value === '' || re.test(e.target.value)) {

            //Handling copy-paste.
            if (e.target.value.length == 6) {
                formik.handleChange(e)
                formik.setFieldValue('code1', e.target.value.substring(0, 1))
                formik.setFieldValue('code2', e.target.value.substring(1, 2))
                formik.setFieldValue('code3', e.target.value.substring(2, 3))
                formik.setFieldValue('code4', e.target.value.substring(3, 4))
                formik.setFieldValue('code5', e.target.value.substring(4, 5))
                formik.setFieldValue('code6', e.target.value.substring(5, 6))

                return true
            }

            if (e.target.value.length > 1) {
                e.target.value = e.target.value.slice(-1)
            }

            if (e.target.name != 'code6') e.target.nextElementSibling.focus();

            formik.handleChange(e)
            return true
        }
    }
    return (
        <>
            <form className='form w-100' onSubmit={formik.handleSubmit} noValidate id='kt_twofactor_twofactor_form'>
                {verificationType?.twoFactorType === 'Email' ? (
                    // Email Verification UI
                    <>
                        <div className="text-center mb-10">
                            <img alt='Logo' src={toAbsoluteUrl('/media/svg/misc/smartphone.svg')} className='mh-125px' />
                        </div>
                        <div id="emailVerification" className="text-center mb-10">
                            <h1 className="text-dark mb-3">Two Step Verification</h1>
                            <div className="text-muted fw-bold fs-5 mb-5">Enter the verification code we sent to</div>
                            <div className="fw-bolder text-dark fs-3">{emailPreview}</div>
                        </div>
                    </>
                ) : (
                    // Authenticator App UI
                    <div id="authenticatorVerification" className="text-center mb-10">
                        <h1 className="text-dark mb-3">Two Step Verification</h1>
                        {!verificationType?.twoFactorAuthenticatorEnabled && verificationType?.qrCodeBase64 ? (
                            <div className="mb-10">
                                <div className="fw-bold text-dark mb-3">Scan this QR code in your authenticator app</div>
                                <img
                                    src={`data:image/png;base64,${verificationType.qrCodeBase64}`}
                                    alt="QR Code"
                                    className="mb-3"
                                    style={{ maxWidth: '200px' }}
                                />
                                <div className="text-muted fs-7 mb-5">
                                    Or enter this code manually: {verificationType.sharedKey}
                                </div>
                            </div>
                        ) : (
                            <>
                                <div className="text-center mb-10">
                                    <img alt='Logo' src={toAbsoluteUrl('/media/svg/misc/smartphone.svg')} className='mh-125px' />
                                </div>
                                <div id="emailVerification" className="text-center mb-10">
                                    <h1 className="text-dark mb-3">Two Step Verification</h1>
                                    <div className="text-muted fw-bold fs-5 mb-5">Enter the authentication code from your authenticator app</div>
                                </div>
                            </>
                        )}
                    </div>
                )}

                <div className="mb-10 px-md-10">
                    <div className="fw-bolder text-start text-dark fs-6 mb-1 ms-1">Type your 6 digit security code</div>
                    <div className="d-flex flex-wrap flex-stack">
                        <input type="text"
                            {...formik.getFieldProps('code1')} className="form-control form-control-solid h-60px w-60px fs-2qx text-center border-primary border-hover mx-1 my-2"
                            onFocus={(e) => { selectAll(e) }} onChange={(e) => { validateCode(e, formik); }} />
                        <input type="text"
                            {...formik.getFieldProps('code2')} className="form-control form-control-solid h-60px w-60px fs-2qx text-center border-primary border-hover mx-1 my-2"
                            onFocus={(e) => { selectAll(e) }} onChange={(e) => { validateCode(e, formik); }} />
                        <input type="text"
                            {...formik.getFieldProps('code3')} className="form-control form-control-solid h-60px w-60px fs-2qx text-center border-primary border-hover mx-1 my-2"
                            onFocus={(e) => { selectAll(e) }} onChange={(e) => { validateCode(e, formik); }} />
                        <input type="text"
                            {...formik.getFieldProps('code4')} className="form-control form-control-solid h-60px w-60px fs-2qx text-center border-primary border-hover mx-1 my-2"
                            onFocus={(e) => { selectAll(e) }} onChange={(e) => { validateCode(e, formik); }} />
                        <input type="text"
                            {...formik.getFieldProps('code5')} className="form-control form-control-solid h-60px w-60px fs-2qx text-center border-primary border-hover mx-1 my-2"
                            onFocus={(e) => { selectAll(e) }} onChange={(e) => { validateCode(e, formik); }} />
                        <input type="text"
                            {...formik.getFieldProps('code6')} className="form-control form-control-solid h-60px w-60px fs-2qx text-center border-primary border-hover mx-1 my-2"
                            onFocus={(e) => { selectAll(e) }} onChange={(e) => { validateCode(e, formik); }} />
                    </div>
                </div>
                <div className="d-flex flex-center">
                    <button type='submit' id='kt_sign_in_submit' className='btn btn-lg btn-primary w-100 mb-5' disabled={formik.isSubmitting || !formik.isValid}>
                        {!loading && <span className='indicator-label'>Log In</span>}
                        {loading && (
                            <span className='indicator-progress' style={{ display: 'block' }}>
                                Please wait...
                                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                            </span>
                        )}
                    </button>
                </div>
            </form>

            <div className="text-center fw-bold fs-5">
                <span className="text-muted me-1">Didn’t get the code ?</span>
                <a href="#" className="link-primary fw-bolder fs-5 me-1">Resend</a>
                <span className="text-muted me-1">or</span>
                <a href="#" className="link-primary fw-bolder fs-5">Call Us</a>
            </div>
        </>
    )
}